import { useState } from "react";

const ViewDetails = ({ showOrderDetails, order }) => {
  const [isBusy, setIsBusy] = useState(false);

  return (
    <button
      onClick={() => {
        setIsBusy(true);
        showOrderDetails(order?._id);
        setTimeout(() => {
          setIsBusy(false);
        }, 1000);
      }}
      className="btn btn-sm btn-icon btn-primary-light btn-wave rounded-circle waves-effect waves-light"
      disabled={isBusy === true ? true : false}
    >
      {isBusy === true ? (
        <span
          className="spinner-border spinner-border-xs"
          role="status"
          aria-hidden="true"
        ></span>
      ) : (
        <>
          <i className="ri-eye-line"></i>
        </>
      )}
    </button>
  );
};

export default ViewDetails;
